import { Button } from "@/components/Button";
import { Link } from "react-router";

export default function SelfGuidedTakeoverPage() {
  return (
    <div className="h-full flex flex-col justify-center items-center gap-6">
      <img src="/door.png" alt="Livly No Access" className="w-[250px]" />
      <h2 className="text-xl font-semibold text-center">Download Livly</h2>
      <p className="text-center">
        Self-Guided Tours can only be taken via Livly’s mobile app. <br />{" "}
        Please check your confirmation email and follow the download
        instructions to log into Livly via the app.
      </p>
      <Link to="/log-out">
        <Button>Ok</Button>
      </Link>
    </div>
  );
}
